import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-muted px-6">
      <div className="text-center max-w-2xl">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-3xl font-semibold text-foreground mb-4">
            Oops! Page Not Found
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            The page you're looking for doesn't exist or has been moved.
            Let's get you back on track to creating amazing marketing content.
          </p>
        </div>

        <div className="space-y-4 mb-12">
          <Button
            onClick={() => navigate('/')}
            size="lg"
            className="w-full sm:w-auto"
          >
            Go to Homepage
          </Button>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="outline"
              onClick={() => navigate('/startups')}
              className="w-full sm:w-auto"
            >
              For Startups
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/retail')}
              className="w-full sm:w-auto"
            >
              For Retail
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/enterprise')}
              className="w-full sm:w-auto"
            >
              For Enterprise
            </Button>
          </div>
        </div>

        <div className="text-sm text-muted-foreground">
          <p>Can't find what you're looking for?</p>
          <Button
            variant="link"
            onClick={() => navigate('/contact')}
            className="text-primary hover:text-primary/80 p-0 h-auto"
          >
            Contact our support team
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
